import { useEffect, useState } from "react";
import { useIsVerified } from "src/components/email-verification";
import { MainCard, MainCardContent, MainCardTitle } from "src/components/main-card-type.tsx";
import {
  checkCalculatorUsageLimitAndRedirect,
  loadSavedCalculatorData,
  sanitizeBrlValue,
  saveCalculatorData,
} from "src/utils/functions";
import { Button } from "src/components/ui/button";
import { calcularIsencaoIR } from "../utils/calculadora-isencao-functions";
import { IsencaoIRResultType } from "../calculadora-isencao-ir";

export const CalculadoraIsencaoInputCard = ({
  setResults,
}: {
  setResults: (value: IsencaoIRResultType | null) => void;
}) => {
  const [message, setMessage] = useState<string>("");
  
  const isVerified = useIsVerified();

  const [salarioBruto, setSalarioBruto] = useState("");
  const calculatorKey = "calculadora-isencao-ir";

  function handleSave() {
    saveCalculatorData(calculatorKey, {
      salarioBruto,
    });
  }

  function clear() {
    setSalarioBruto("");
    setMessage("");
    setResults(null);
  }

  useEffect(() => {
    const savedData = loadSavedCalculatorData(calculatorKey);
    if (!savedData) return;
    setSalarioBruto((savedData.salarioBruto as string) || "");
  }, []);

  function calcular() {
    if (!salarioBruto || salarioBruto === "0") {
      setMessage("Informe o salário bruto mensal.");
      setResults(null);
      return;
    }

    setMessage("");

    try {
      const valorSalario = Number.parseFloat(
        salarioBruto.replace(/[^0-9,-]+/g, "").replace(",", ".")
      );

      const resultado = calcularIsencaoIR(valorSalario);
      setResults(resultado);
    } catch (error) {
      setMessage(error instanceof Error ? error.message : "Erro no cálculo. Verifique os dados informados.");
      setResults(null);
    }
  }

  return (
    <MainCard>
      <MainCardTitle>Calculadora de Isenção do Imposto de Renda</MainCardTitle>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
          checkCalculatorUsageLimitAndRedirect(calcular);
          // calcular();
        }}
      >
        <MainCardContent>
          <div>
            <label className="block mb-2 font-medium text-sm" htmlFor="salario-bruto-id">
              Salário bruto mensal (em R$) *
            </label>
            <p className="text-xs text-gray-600 mb-2">
              Insira seu salário bruto mensal para descobrir o impacto da nova regra de isenção.
            </p>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="salario-bruto-id"
                placeholder="0,00"
                type="text"
                value={salarioBruto}
                onChange={(event) => setSalarioBruto(sanitizeBrlValue(event))}
              />
            </div>
          </div>
        </MainCardContent>

        <div className="flex justify-between">
          <Button
            disabled={!isVerified}
            type="submit"
            variant={"default"}
            className="sm:w-[150px]"
          >
            Calcular Agora
          </Button>

          <div className="flex flex-col sm:flex-row items-center gap-2">
            <a
              href="/calculadoras/salario-liquido"
              className="text-sm text-primary text-center hover:underline"
            >
              Ver salário líquido completo
            </a>

            <Button onClick={clear} type="button" variant={"ghost"}>
              Limpar
            </Button>
          </div>
        </div>
      </form>

      <p className="text-red-800 text-center mt-2 font-bold">{message}</p>
    </MainCard>
  );
};